module.exports = __webpack_public_path__ + "static/img/LOGO／黑@2x(1).2c44ecbe.png";